module.exports = __webpack_public_path__ + "static/media/21_2.a5d929be.png";